import kitSchemaCafePacket from "../../tests/fixtures/site-packet-minimal.json";
import { parseSitePacket, type SitePacket } from "./site-packet";

const staticDraftPackets = new Map<string, SitePacket>([
  [
    "kit-schema-cafe",
    parseSitePacket(kitSchemaCafePacket),
  ],
]);

/** Node-free. Only packets with `tenant.draft === true` resolve. */
export function lookupDraftSitePacket(slug: string): SitePacket | null {
  const packet = staticDraftPackets.get(slug);
  if (!packet) return null;
  if (!packet.tenant.draft) return null;
  if (packet.tenant.slug !== slug) return null;
  return packet;
}
